<div class="track-item-header">
  <!-- Track cover -->
  <div class="track-item-header__img-box">
    <img src="{{ beat?.images.original }}" alt="{{ beat?.name }} cover" />
  </div>

  <!-- Track name -->
  <div class="track-item-header__name-box">
    <!-- Play / pause btn -->
    <div class="track-item-header__play-pause">
      @if (player?.currentTrack?.id !== beat?.id || player.status !== PlayStatus.Playing) {
        <div class="track-item-header__btn-box theme-headerBlockBeatPage__playBtn" (click)="play($event, beat)">
          <span class="btv-icon-play theme-headerBlockBeatPage__playBtn"></span>
        </div>
      }

      @if (player?.currentTrack?.id === beat?.id && player.status === PlayStatus.Playing) {
        <div class="track-item-header__btn-box theme-headerBlockBeatPage__playBtn" (click)="pause($event)">
          <span class="btv-icon-pause theme-headerBlockBeatPage__playBtn"></span>
        </div>
      }
    </div>

    <div class="track-item-header__box-name">
      <h1 class="common-section-title track-item-header__name theme-headerBlockBeatPage__beatName">
        {{ beat?.name }}
      </h1>
      @if (showBeatmakerName) {
        <span class="track-item-header__by bm--cut"
          >Beat by
          <a class="track-item-header__author" routerLink="/bm/{{ beat?.beatmakerId }}">
            {{ beat?.beatmakerName }}
          </a>
        </span>
        @if (beat?.beatmakerVerified) {
          <bmcore-verify-icon></bmcore-verify-icon>
        }
      }
    </div>

    <!-- Show on mobile viewport-->
    <div class="track-item-header__min-price-mob">
      <bmcore-min-price [minPrice]="beat?.minPrice"></bmcore-min-price>
    </div>
  </div>

  <!-- Styles / moods / BPM -->
  <div class="track-item-header__info-box">
    <!--1-->
    <div class="track-item-header__info-wrapper">
      <div class="btv-icon-style theme-headerBlockBeatPage__beatInfoIcon"></div>
      <p class="track-item-header__item--style theme-headerBlockBeatPage__beatInfo">
        {{ lg.tracksBlock.style }}: {{ beat?.style.title }}
      </p>
    </div>
    <!--2-->
    <div class="track-item-header__info-wrapper">
      <div class="btv-icon-bpm theme-headerBlockBeatPage__beatInfoIcon"></div>
      <p class="track-item-header__item--mood theme-headerBlockBeatPage__beatInfo">
        {{ lg.tracksBlock.mood }}: {{ beat?.mood.title }}
      </p>
    </div>
    <!--3-->
    <div class="track-item-header__info-wrapper">
      <div class="btv-icon-mood theme-headerBlockBeatPage__beatInfoIcon"></div>
      <p class="track-item-header__item--bpm theme-headerBlockBeatPage__beatInfo">
        {{ lg.tracksBlock.bpmDescription }}: {{ beat?.bpm }}
      </p>
    </div>
    <!--4-->
    <!--Comment samples block (don't delete)-->
    <!--<div class="icon-samples"></div>
    <p class="track-item-header__item&#45;&#45;samples">
      {{ lg.tracksBlock.usingSamples  }}: XXX
    </p>-->
  </div>

  <!-- Btn with price -->
  <div class="track-item-header__btn-box">
    <!-- Download button -->
    <div [ngClass]="{ 'track-item-header__btn_down': beat?.demoDownloading }">
      <bmcore-download-btn
        [demoDownloading]="beat?.demoDownloading"
        [downloadMp3Url]="beat?.mp3"
        [parentComponent]="'track-item-header'"
        [trackId]="beat?.id"
      >
      </bmcore-download-btn>
    </div>

    <!-- Buy button -->
    <div class="track-item-header__btn-buy">
      <!-- После рафакторинга плеера Димыч заменил beat.id на player.currentTrack.id. -->
      <!-- Но перестало работать добавление трека в корзину, поэтому вернул обратно -->
      <!-- (clickHandler)="wantToAddBeat($event, player.currentTrack.id)"-->
      <bmcore-button
        class="track-item__desktop-mode"
        [themeBtnClass]="
          checkIsTrackInCart(beat.id)
            ? 'theme-btn__headerBlockBeatPage-btnGoToCart'
            : 'theme-btn__headerBlockBeatPage-btnBuy'
        "
        [themeIconClass]="
          checkIsTrackInCart(beat.id)
            ? 'theme-icon__headerBlockBeatPage-btnIconGoToCart'
            : 'theme-icon__headerBlockBeatPage-btnIconBuy'
        "
        title="{{ checkIsTrackInCart(beat.id) ? lg.button.goToCart : lg.button.buy }}"
        icon="btv-icon-cart"
        [styleName]="checkIsTrackInCart(beat.id) && 'in cart'"
        [routerPath]="checkIsTrackInCart(beat.id) && checkoutPage"
        (clickHandler)="!checkIsTrackInCart(beat.id) && wantToAddBeat($event, beat.id)"
      >
      </bmcore-button>
    </div>

    <!-- Show on desktop viewport-->
    <div class="track-item-header__min-price-desktop">
      <bmcore-min-price [minPrice]="beat?.minPrice"></bmcore-min-price>
    </div>
  </div>
</div>
